let sliderContainer = $('.js_brand-page__images-container')
let nextEl = sliderContainer.find('.js_brand-page__images-next')
let prevEl = sliderContainer.find('.js_brand-page__images-prev')

new Swiper('.js_brand-page__images-wrapper', {
    slidesPerView: 1,
    breakpoints: {
        576: {
            slidesPerView: 2,
            spaceBetween: 20,
        }, 
        768: {
            slidesPerView: 3,
            spaceBetween: 20,
        }
    },
    navigation: {
        nextEl: nextEl[0],
        prevEl: prevEl[0],
    },
    loop: true,
    modules: [SwiperModes.Navigation]
})

lightGallery(sliderContainer[0], {
    selector: '.js_global__gallery-item',
    licenseKey: 'your_license_key',
    speed: 500,
    download: false,
    plugins: [window.lgThumbnail],
})